import api from './api.js';

export const libraryService = {
  // Get all library resources
  getResources: (params = {}) => api.get('/library/resources', { params }),
  
  // Get resource by ID
  getResource: (id) => api.get(`/library/resources/${id}`),
  
  // Create new resource (teacher/admin only)
  createResource: (data) => api.post('/library/resources', data),
  
  // Update resource (teacher/admin only)
  updateResource: (id, data) => api.put(`/library/resources/${id}`, data),
  
  // Delete resource (teacher/admin only)
  deleteResource: (id) => api.delete(`/library/resources/${id}`),
  
  // Search resources
  searchResources: (query, params = {}) => 
    api.get('/library/resources/search', { 
      params: { ...params, q: query } 
    }),
  
  // Get resources by category
  getResourcesByCategory: (categoryId, params = {}) => 
    api.get(`/library/resources/category/${categoryId}`, { params }),
  
  // Get resource categories
  getCategories: () => api.get('/library/categories'),
  
  // Create category (admin only)
  createCategory: (data) => api.post('/library/categories', data),
  
  // Update category (admin only)
  updateCategory: (id, data) => api.put(`/library/categories/${id}`, data),
  
  // Delete category (admin only)
  deleteCategory: (id) => api.delete(`/library/categories/${id}`),
  
  // Download resource (returns presigned URL for S3 files)
  downloadResource: (id) => api.get(`/library/resources/${id}/download`),
  
  // Track resource access
  trackAccess: (id) => api.post(`/library/resources/${id}/access`),
  
  // Get my downloads
  getMyDownloads: (params = {}) => api.get('/library/my-downloads', { params }),
  
  // Get download history
  getDownloadHistory: (params = {}) => api.get('/library/download-history', { params }),
  
  // Add to favorites
  addToFavorites: (id) => api.post(`/library/resources/${id}/favorite`),
  
  // Remove from favorites
  removeFromFavorites: (id) => api.delete(`/library/resources/${id}/favorite`),
  
  // Get my favorites
  getMyFavorites: (params = {}) => api.get('/library/my-favorites', { params }),
  
  // Upload resource file
  uploadResourceFile: (formData) => 
    api.post('/library/resources/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }),

  // Upload resource with progress tracking
  uploadResource: (formData, onProgress) => 
    api.post('/library/resources/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: (progressEvent) => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        if (onProgress) onProgress(percentCompleted);
      }
    }),

  // Note: Download tracking is handled automatically by the download endpoint
  
  // Get popular resources
  getPopularResources: (params = {}) => 
    api.get('/library/resources/popular', { params }),
  
  // Get recent resources
  getRecentResources: (params = {}) => 
    api.get('/library/resources/recent', { params }),
  
  // Get recommended resources
  getRecommendedResources: (params = {}) => 
    api.get('/library/resources/recommended', { params }),
  
  // Get resource statistics (admin only)
  getResourceStats: (id) => api.get(`/library/resources/${id}/stats`),
  
  // Get library analytics (admin only)
  getLibraryAnalytics: (params = {}) => 
    api.get('/library/analytics', { params }),
  
  // Get resource usage report (admin only)
  getUsageReport: (params = {}) => 
    api.get('/library/usage-report', { params }),
  
  // Export library data (admin only)
  exportLibraryData: (params = {}) => 
    api.get('/library/export', { 
      params, 
      responseType: 'blob' 
    }),
  
  // Get resource tags
  getResourceTags: () => api.get('/library/tags'),
  
  // Get resources by tag
  getResourcesByTag: (tag, params = {}) => 
    api.get(`/library/resources/tag/${tag}`, { params }),
  
  // Get resource metadata
  getResourceMetadata: (id) => api.get(`/library/resources/${id}/metadata`),
  
  // Update resource metadata (admin only)
  updateResourceMetadata: (id, data) => 
    api.put(`/library/resources/${id}/metadata`, data),
};
